import { useEffect, useRef } from 'react';

import { GlobeIcon } from '@braskai/icons';
import { useLocalStorage } from 'react-use';

import { useProducts } from '@/entities/pricing';
import { useBalanceStore } from '@/entities/user/balance';

import { useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { IS_WHITE_LABEL } from '@/shared/lib/environments';
import { PATHS } from '@/shared/routes/paths';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PlanCategory } from '@/shared/types/Billing';
import { PromoBanner } from '@/shared/ui/PromoBanner';

const LS_SHOW_SIDEBAR_BANNER = 'showSidebarBanner';

export const BannerSidebar = () => {
  const [show, setShowBanner] = useLocalStorage(LS_SHOW_SIDEBAR_BANNER, true);

  const isFirstLoadRef = useRef<boolean>(false)

  const user = useAppSelector((state) => state.user);
  const { api_credentials_generated: apiCredentialsGenerated } = user || {};

  const {
   hasEnterprisePlan,
  } = useBalanceStore();
  const { products } = useProducts();
  const businessPlans = products?.plan?.filter((planData) => planData.category === PlanCategory.Business);
  const hasBusinessPlans = businessPlans?.find((planData) => planData.id === user?.subscription?.plan.product_id);
  const hasApiAvailablePlans = hasEnterprisePlan || hasBusinessPlans;

  const handleClose = () => {
    setShowBanner(false);
    MixpanelEvents.apiBannerClose();
  };

  const handleClickLink = () => {
    MixpanelEvents.apiBannerClick();
  };

  const isShowBanner = show && !apiCredentialsGenerated && !IS_WHITE_LABEL

  useEffect(() => {
    if (isShowBanner && !isFirstLoadRef.current) {
      isFirstLoadRef.current = true;
      MixpanelEvents.apiBannerShown();
    }
  }, [isShowBanner]);

  if (!isShowBanner) {
    return null;
  }

  return (
      <PromoBanner
        title="Use Rask API across your products"
        link={{
          children: hasApiAvailablePlans ? 'Get API key' : 'Upgrade',
          to: `/${hasApiAvailablePlans ? PATHS.account : PATHS.pricing}`,
          onClick: handleClickLink,
        }}
        icon={<GlobeIcon />}
        variant="primary"
        onClose={handleClose}
      />
  );
};
